import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';

import ModalVideo from 'react-modal-video';
import './usestyle.css';
// ES6 class-style
class Use extends PreLoginSessionCheck {
	constructor (props) {		
	    super(props)
		this.productDetails = localStorage.getItem('proDetail');
		this.openModal = this.openModal.bind(this)
	}
	getProductDetails(){		
	    if(this.productDetails != {} && this.productDetails != undefined){
	      return JSON.parse(this.productDetails);
	    }
	}

	openModal (someValue) {
		this.setState({isOpen: true})
		this.videoId = someValue
		console.log(this.videoId);
	  }

	loadVideoContent(){
		if(this.props.owner==="plp" || this.props.owner==="cbse"){
			return(
			<div>
				<div className='loadvid'>
					<div data-ga="Home - Star Students - Shreyas Kumar" className="swiper-slide">
						<div className="img-box popup-youtube vid-box" onClick={this.openModal.bind(null,'hsifPyadKko')}>
							<img src="../img/plprev_student2.jpg" alt="Vidya Mandir Mylapore Grade 6 students review Personalised Learning program"/>
							<a><span className="play-btn"></span></a>
						</div>
					</div>
					
					<div data-ga="Home - Star Students - Uday Saharia" className="swiper-slide">
						<div className="img-box popup-youtube vid-box" onClick={this.openModal.bind(null,'6fBBbVLBlrw')}>
							<img src="../img/plprev_student3.jpg" alt="Vidya Mandir Mylapore Grade 9 students share feedback about Personalised Learning program"/>
							<a><span className="play-btn"></span></a>
						</div>
					</div>
					
					<div data-ga="Home - Star Students - Yamini Prashanth" className="swiper-slide">
						<div className="img-box popup-youtube vid-box" onClick={this.openModal.bind(null,'TS7AZ-QE66A')}>
							<img src="../img/plprev_student1.jpg" alt="Grade 9 Vidya Mandir Mylapore students share feedback about Personalised Learning program"/>
							<a><span className="play-btn"></span></a>
						</div>
					</div>
					
					<div data-ga="Home - Star Students - Anuradha" className="swiper-slide">
						<div className="img-box popup-youtube vid-box" onClick={this.openModal.bind(null,'5Dn6-cvFJ5o')}>
							<img src="../img/plprev_student4.jpg" alt="Tvisha of Grade 5 from Deens academy shares her comments on Personalised Learning program"/>
							<a><span className="play-btn"></span></a>
						</div>
					</div>
					
				</div>
				<ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId={this.videoId} onClose={() => this.setState({isOpen: false})} />
					</div>)
		}else{
			return(
				<div>
					<img src={this.props.imgName} alt="Young children using HeyMath! to learn Maths on their laptops"/>
					</div>
			)
		}
	}

  render() {
	this.proID = localStorage.getItem('product');
  	const gradeName = this.getProductDetails()[this.proID].ClassName;
  	
  	return(
	<section className={"mtb usehm student useComp "+this.props.owner} >
		<div className="row">
			<div className="container">
				<h2>How students make the best use of our product</h2>
				<div className="row">
					 <div className="col-md-7">
					 	<div className="img-gallery">
					 		{this.loadVideoContent()}
					 	</div>
					 </div>
					  <div className="col-md-5">					 	
						  {( () => {
							  if(this.props.owner == "plp"){
								  return(<ul className="galry-list">
								  	<li>Go through topics after they have been completed in school</li>
							 		<li>Revise topics covered for school tests</li>
							 		<li>Recommended usage: 2 hours per week</li>
								  </ul>);
							  }else if(this.props.owner == "cbse"){
								  /*if(gradeName == "Class 9"){
									  return(<ul className="galry-list">
									  	<li>Allocate 2 hours a week to complete 5 topics</li>
								 		<li>Practice and master topics once completed in school</li>
								 		<li>Revise topics where you scored C or below</li>
									  </ul>);
								  }else if(gradeName == "Class 10"){
									  return(<ul className="galry-list">
									  	<li>Allocate 2 hours a week to complete 6 topics</li>
								 		<li>Practice and master topics once completed in school</li>
								 		<li>Revise topics where you scored C or below</li>
									  </ul>);
								  }else{
									  return(<ul className="galry-list">
									  	<li>Allocate 2 hours a week to complete 5 topics</li>
								 		<li>Practice and master topics once completed in school</li>
								 		<li>Revise topics where you scored C or below</li>
									  </ul>);
								  }*/
								  return(<ul className="galry-list">
								  		<li>Work on topics that have been completed in school</li>
									  	<li>Allocate 2 hours a week for practice</li>
								 		<li>Revise topics where you have scored C or below</li>
									  </ul>);
							  }else{
								   return(<ul className="galry-list">
								  	<li>Spend 20 minutes a day going through lessons</li>
							 		<li>Do practice problems before school tests</li>
							 		<li>Go through relevant lessons before school tests</li>
								  </ul>);
							  }
						  })()}
					 </div>
				</div> 
			</div>
		</div>
	</section>
  	);
  }
}

export default Use; 


// WEBPACK FOOTER //
// ./src/prelogin/src/components/Use.js